import { useEffect, useState } from "react";
import { ApiError } from "../../../api/http";
import { fetchStaffShifts, type StaffShiftSummary } from "../../../api/staffApi";
import { EmptyState } from "../components/EmptyState";
import { ShiftCard } from "../components/ShiftCard";
import { SkeletonCard } from "../components/SkeletonCard";
import { StaffAlert } from "../components/StaffAlert";
import { StaffAppShell } from "../components/StaffAppShell";

export function StaffTimeCorrectionsPage() {
  const [shifts, setShifts] = useState<StaffShiftSummary[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    (async () => {
      try {
        const past = await fetchStaffShifts("past");
        setShifts(past.filter((s) => s.assignmentStatus === "active").slice(0, 20));
      } catch (e) {
        setError(e instanceof ApiError ? e.message : "Could not load shifts.");
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <StaffAppShell title="Time corrections" showBack backTo="/staff/me" hideNav>
      <div className="staff-page">
        <p className="muted staff-lead">
          Open a completed shift and use <strong>Request time correction</strong> after clock-out.
        </p>

        {error ? <StaffAlert onDismiss={() => setError(null)}>{error}</StaffAlert> : null}

        {loading ? (
          <SkeletonCard />
        ) : shifts.length === 0 ? (
          <EmptyState title="No past shifts" detail="Time corrections are submitted from a shift detail page." />
        ) : (
          <div className="staff-card-stack">
            {shifts.map((shift) => (
              <ShiftCard
                key={shift.id}
                shift={shift}
                to={`/staff/shifts/${shift.id}`}
                trailing={<span className="staff-inline-link">Open shift →</span>}
              />
            ))}
          </div>
        )}

        <p className="muted staff-footer-note">
          Need help? Contact management through your usual channel.
        </p>
      </div>
    </StaffAppShell>
  );
}
